// Custom entry point.
//
// LiveKit needs its WebRTC globals registered before any app code runs, so we
// do it here ahead of handing off to Expo Router's default entry. The LiveKit
// packages are native-only (shimmed out on web in metro.config.js), so the
// registration is guarded to native platforms.
//
// autoConfigureAudioSession: false hands the iOS AVAudioSession to CallKit
// (react-native-callkeep); audio is enabled via RTCAudioSession when CallKit
// activates the session. See services/calls/callKeep.ts.
const { Platform } = require('react-native');

if (Platform.OS !== 'web') {
    const { registerGlobals } = require('@livekit/react-native');
    registerGlobals({ autoConfigureAudioSession: false });
}

require('expo-router/entry');
